const getters = {
  current_user: state => state.user.current_user,
  Navigation: state => state.navigation.Navigation,
  cartCount: state => state.cart.cartCount,
  keywords: state => state.cart.keywords,
  MassageCount: state => state.cart.MassageCount
  // Cart: state => state.cart.goods_list
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js